import React, { createContext, useMemo, useState } from "react";

export interface ITheme {
    theme: "dark" | "light";
    setTheme: (e: ITheme["theme"]) => void;
    changeOnScroll: boolean;
    setChangeOnScroll: (v: boolean) => void;
}

interface ThemeConfig {
    theme?: ITheme["theme"];
}

export const ThemeContext = createContext<ITheme>({
    theme: "dark",
    changeOnScroll: false,
    setTheme: () => {},
    setChangeOnScroll: () => {},
});

export function ThemeProvider({
    children,
    theme: defaultTheme,
}: React.PropsWithChildren<ThemeConfig>) {
    const [theme, setTheme] = useState<ITheme["theme"]>(defaultTheme ?? "dark");
    const [changeOnScroll, setChangeOnScroll] =
        useState<ITheme["changeOnScroll"]>(false);

    const value = useMemo(
        () => ({ theme, setTheme, changeOnScroll, setChangeOnScroll }),
        [theme, changeOnScroll]
    );

    return (
        <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    );
}
